//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "addRole",
  data() {
    return {
      ruleFormAddRole: {
        roleName: "",
        roleRemark: "",
      },
      authData: [],
      ownAuthData: [],
      checkedAuthData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      selectedAuth: [],
      activeNames: [],
      rules: {
        roleName: {
          required: true,
          message: "请输入角色名称",
          trigger: "blur",
        },
      },
    };
  },
  props: {
    dialogAddRoleVisible: {
      type: Boolean,
      default: () => true,
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "dialogAddRoleVisible");
    },
    /**
     * @description: 选中
     * @Author: yangsibo
     * @Date: 2022-05-25 09:48:36
     * @param {*} data
     * @param {*} checked
     * @param {*} indeterminate
     * @return {*}
     */
    handleCheckChange(data, checked, indeterminate) {
      let selectedAuth = this.$refs.tree.getCheckedNodes(false, true);
      this.selectedAuth = selectedAuth.filter((item) => {
        return item.menuType == 4;
      });
    },
    /**
     * @descripttion: 保存添加角色信息
     * @Author: juanjuanhui
     * @Date: 2022-02-23 17:05:15
     */
    handleSaveAddRole() {
      this.$refs.ruleFormAddRole.validate(async (valid) => {
        if (valid) {
          let sRefRoleMenuButtonDtos = this.$refs.tree
            .getCheckedNodes(false, true)
            .map((item) => {
              return {
                menuId: item.id, //按钮id
              };
            });
          try {
            let { status } = await this.$http.role.addSRole({
              ...this.ruleFormAddRole,
              sRefRoleMenuButtonDtos,
              systemType: this.systemType,
            });
            if (status == 1) {
              this.$message({
                type: "success",
                message: "新增角色成功",
                duration: 2000,
              });
              this.close();
              this.$emit("getRoleList");
            }
          } catch (error) {}
        } else {
          return false;
        }
      });
    },
    /**
     * @description: 获取选择权限
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:54
     * @return {*}
     */
    async selectSMenuTree() {
      try {
        let { data } = await this.$http.common.selectSMenuTree({
          systemType: this.systemType,
        });
        if (data) {
          this.authData = data;
        }
      } catch (error) {}
    },
  },
  created() {},
  mounted() {
    this.selectSMenuTree();
  },
};
